<template>
    <div class="allcourse" style="min-height: calc(100vh - 100px);">
        <section class="course-listing-banner-section gradiant-banner">
            <b-container>
                <b-navbar toggleable="md" type="dark" class="course-listing-banner-nav">
                    <b-navbar-brand href="#"
                    >All {{ course_name }} Courses
                    </b-navbar-brand
                    >
                    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                    <b-collapse id="nav-collapse" is-nav>
                        <!-- Right aligned nav items -->
                        <filter-bar
                                v-if="filterData"
                                :filterData="filterData"
                                :categoryId="categoryId"
                                @applyFilter="applyFilter"
                        ></filter-bar>
                    </b-collapse>
                </b-navbar>
            </b-container>
        </section>
        <course-listing-view v-if="!noResult"
                             :course_name="course_name"
                             :courseArray="courseArray"
                             :course_count="courseArray.length"
                             :showHeading="false"
        />
        <div v-if="noResult">
            <loader></loader>
        </div>
    </div>
</template>

<script>
    import CourseListingView from "../components/CourseListing/CourseListingView.vue";
    import FilterBar from "../components/Templates/FilterBar.vue";
    import {videoApi} from "../services/videoApi";
    import {ContentLoader} from "vue-content-loader";
    import Loader from "../components/Loader";
    import {commonFunctions} from "../Commonjs/commonFunctions";

    export default {
        components: {
            Loader,
            CourseListingView,
            FilterBar,
            ContentLoader
        },
        data() {
            return {
                course_name: "",
                courseArray: [],
                filterData: {},
                categoryId: "",
                noResult: true
            };
        },
        methods: {
            applyFilter(courseData) {
                this.courseArray = courseData;
            }
        },
        mounted() {
            this.course_name = this.$route.query.course_name;
            this.categoryId = this.$route.query.category_id;
            commonFunctions.ToggleNoScroll();
            if (this.course_name) {
                videoApi
                    .getCourseByCategory(this.$route.query.category_id)
                    .then(res => {
                        this.filterData = res.data.filters;
                        if (res.data.courseResponseByCategory) {
                            if (res.data.courseResponseByCategory.courseResponse.length > 0) {
                                res.data.courseResponseByCategory.courseResponse.forEach(
                                    course => {
                                        this.courseArray.push(course);
                                    }
                                );
                            }
                            if (res.data.courseResponseByCategory.subCourses.length > 0) {
                                res.data.courseResponseByCategory.subCourses.forEach(sub => {
                                    if (sub.courseResponse.length > 0) {
                                        sub.courseResponse.forEach(course1 => {
                                            this.courseArray.push(course1);
                                        });
                                    }
                                    if (sub.subCourses) {
                                        sub.subCourses.forEach(sub1 => {
                                            if (sub1.courseResponse.length > 0) {
                                                sub1.courseResponse.forEach(course2 => {
                                                    this.courseArray.push(course2);
                                                });
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        this.noResult = false;
                        commonFunctions.ToggleNoScroll();
                    })
                    .catch(() => {
                        this.noResult = true;
                    });
            } else {
                videoApi
                    .getAllCourses()
                    .then(res => {
                        this.noResult = false;
                        commonFunctions.ToggleNoScroll();
                        this.courseArray = res.data.courseResponses;
                        this.filterData = res.data.filters;
                    })
                    .catch(e => {
                        this.noResult = true;
                        console.error("api failed", e);
                    });
            }
        }
    };
</script>

<style></style>
